import { customStyled, FlexBox } from '@rario/shared-components'

export const ContentWrapper = customStyled(FlexBox)`
flex-direction:column;
padding-bottom:60px;
overflow:hidden;
padding-inline:15px;
ul {
    padding-left: 12px;
  }
`
